import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** The box `UiTooltipDirective` puts in the overlay; not meant to be used on its own. */
@Component({
  selector: 'fr8bot-ui-tooltip-panel',
  host: {
    '[id]': 'panelId()',
    '[attr.role]': "announce() ? 'tooltip' : null",
    '[attr.aria-hidden]': "announce() ? null : 'true'",
    class: 'ui-tooltip-panel',
  },
  templateUrl: './ui-tooltip-panel.component.html',
  styleUrl: './ui-tooltip-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTooltipPanelComponent {
  readonly text = input('');
  readonly panelId = input('');
  readonly announce = input(true);
}
